import React, { Fragment, useContext, useState,useEffect } from "react";
import DataTable from "react-data-table-component";
import {  DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { Spinner } from "../../AbstractElements";
// import DeleteConfirmation from "./DeleteConfirmation";
import CustomizerContext from "../../_helper/Customizer";
import DeleteConfirmation from "./DeleteConfirmation";
import { zoneCaptureColumns } from "../../Data/ZoneCapture/ZoneCapture";
import SharedDataContext from "../../_helper/SharedData";
import { getAllZoneCapture ,getAllZoneCaptureBySearch} from "../../Services/Zone.service";
import { formatDateTime } from "../../Services/Shared.service";
import { showAlert } from "../../Services/Shared.service";
import { Breadcrumbs } from "../../AbstractElements"
import SearchTable from "../Common/Component/SearchTable";

const ZoneCountTable = () => {
  const { globalCityField,dateFilter } = useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const { mix_background_layout } = useContext(CustomizerContext);
  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    fetchTableData();
  }, [searchData]);

  useEffect(() => {
    fetchTableData();
  }, [, pagination, rowsPerPage,dateFilter.startDate, dateFilter.endDate]);

  const fetchTableData = () => {
    // if (globalCityField.value?.id !== 4) {
    //   showAlert("error", "Zone Capture is Currently Only available for Bangalore");
    // }
    if (filterData.length == 0 && !searchData){
      let obj = {
        fromDate: FormatFromDate,
        toDate: FormatToDate,
        page: pagination,
        size: rowsPerPage,
      };
      setLoader(true);
      getAllZoneCapture(obj)
        .then((resp) => {
          setPaginationTotalRows(resp.data.count);
          setTableData(resp.data.searchResponse);
          setLoader(false);
        })
        .catch((err) => {
          disableLoaders();
          showAlert("error", "Zone Capture Not Found");
        });
    }else if(searchData && filterType == "search"){
      let obj = {
        fromDate: FormatFromDate,
        toDate: FormatToDate,
        name: searchData,
        page: pagination,
        size: rowsPerPage,
      };
      setLoader(true);
      getAllZoneCaptureBySearch(obj)
        .then((resp) => {
          setPaginationTotalRows(resp.data.count);
          setTableData(resp.data.searchResponse);
          setLoader(false);
        })
        .catch((err) => {
          disableLoaders();
          showAlert("error", "Zone Capture Not Found");
        });
    }
  };

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
  };

  const conditionalRowStyles = [
    {
      when: (row) => row["Deleted"],
      style: (row) => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : "" }),
    },
  ];

  const processData = tableData.map((element, index) => {
    return {
      driverName:element.driverName? element.driverName:"_",
      cabNumber: element.carNo ? element.carNo : "-",
      zone: element.zone ? element.zone : "-",
      bookingId: element.megaCabsBookingNo ? element.megaCabsBookingNo : "-",
      agentName: element.agentName ?  element.agentName : "-",
      driverMobile: element.driverMobile ? element.driverMobile : "-",
      pickUpDateTime:element.pickUpDateTime?  moment(new Date(element.pickUpDateTime)).format(
        "MMM DD HH:mm"):"_",
      tripEndTime:element.tripEndTime?  moment(new Date(element.tripEndTime)).format(
        "MMM DD HH:mm" ):"_",
 
      tripStatus:element.tripStatus?element.tripStatus:"_"
    };
  });
  return (
    <Fragment>
      <div className="table-responsive zone-count-table">
        <Breadcrumbs
        parent="zone capture"
        mainTitle="Vendor"
        
        span3={<SearchTable
          placeholder={"Search by Zone Name"}
          searchData={searchData}
          setSearchData={setSearchData}
          setFilterData={setFilterData}
          setFilterType={setFilterType}
           />}
      />
        <DataTable
          columns={zoneCaptureColumns}
          data={processData}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          // paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          progressPending={loader}
        //   triggerRefresh={triggerRefresh}
          conditionalRowStyles={conditionalRowStyles}
          progressComponent={
            <div className="loader-box" style={{ height: "57vh" }}>
              <Spinner
                attrSpinner={{
                  className: "loader-3",
                  style: {
                    width: "30px",
                    height: "30px",
                    borderColor: "#39B54A",
                    borderBottomColor: "transparent",
                  },
                }}
              />
            </div>
          }
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
    </Fragment>
  );
};

export default ZoneCountTable;
